import { useEffect, useState } from "react";
import { formatRunningElapsed, resolveRunStartedAt } from "./formatRunningElapsed";

export default function RunningElapsedLabel({ source, isRunning = false }) {
  const startedAt = resolveRunStartedAt(source);
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    if (!isRunning || !startedAt) return undefined;
    const id = window.setInterval(() => setNowMs(Date.now()), 15000);
    return () => window.clearInterval(id);
  }, [isRunning, startedAt]);

  if (!isRunning) return null;

  const label = formatRunningElapsed(startedAt, nowMs);
  if (!label) {
    return <span className="admin-ds-running-elapsed muted">in progress</span>;
  }

  return (
    <span className="admin-ds-running-elapsed muted" title={startedAt ? `Started ${startedAt}` : undefined}>
      {label}
    </span>
  );
}
